(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size' || this.getAttribute('data-sticky-type') === 'attachment';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["makebeauty-product-experience"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (scope = document) => {
      const root = scope.querySelector('[data-mb-product-experience]') || document.querySelector('[data-mb-product-experience]');

      if (!root || root.dataset.initialized === 'true') return;

      root.dataset.initialized = 'true';

      const info = document.querySelector('.product__info-container');

      if (info) {
        const title = info.querySelector('.product__title');
        const stock = document.createElement('div');
        const available = root.dataset.available === 'true';
        stock.className = `mb-stock-shipping${available ? '' : ' is-unavailable'}`;
        stock.innerHTML = available
          ? `<span class="mb-stock-shipping__dot" aria-hidden="true"></span><span>${root.dataset.stockText}</span><span class="mb-stock-shipping__separator" aria-hidden="true">|</span><span>${root.dataset.shippingText}</span><span class="mb-stock-shipping__bolt" aria-hidden="true">↯</span>`
          : `<span class="mb-stock-shipping__dot" aria-hidden="true"></span><span>${root.dataset.unavailableText}</span>`;

        if (title) info.insertBefore(stock, title);

        const renderSocialProof = () => {
          if (info.querySelector('.mb-social-proof')) return true;

          const badge = info.querySelector('.jdgm-prev-badge');

          if (!badge && document.readyState !== 'complete') return false;

          const row = document.createElement('div');
          const ratingValue = Number(badge?.dataset.averageRating || 5);
          const soldCount = Number.parseInt(root.dataset.soldCount || '0', 10);
          const digits = Number.isInteger(ratingValue) ? 0 : 2;
          const rating = ratingValue.toLocaleString('pt-BR', {
            minimumFractionDigits: digits,
            maximumFractionDigits: 2
          });
          const soldLabel = Math.max(0, soldCount).toLocaleString('pt-BR');
          row.className = 'mb-social-proof';

          if (badge) {
            row.appendChild(badge);
          } else {
            const fallback = document.createElement('span');
            fallback.className = 'mb-social-proof__fallback-stars';
            fallback.setAttribute('aria-label', `${rating} de 5 estrelas`);
            fallback.textContent = '★★★★★';
            row.appendChild(fallback);
          }

          const sales = document.createElement('span');
          sales.className = 'mb-social-proof__sales';
          sales.innerHTML = `<strong>${rating}</strong> (${soldLabel} vendidos)`;
          row.appendChild(sales);

          if (title) info.insertBefore(row, title);

          return true;
        };

        if (!renderSocialProof()) {
          const observer = new MutationObserver(() => {
            if (renderSocialProof()) observer.disconnect();
          });
          observer.observe(info, { childList: true, subtree: true });
          window.setTimeout(() => {
            renderSocialProof();
            observer.disconnect();
          }, 4000);
        }

        const upsell = root.querySelector('[data-mb-upsell]');

        if (upsell && upsell.querySelector('.mb-upsell__card')) {
          const rail = upsell.querySelector('.mb-upsell__rail');
          const cards = Array.from(upsell.querySelectorAll('.mb-upsell__card'));
          const limit = Math.max(1, Number.parseInt(upsell.dataset.mbLimit || '3', 10));
          const normalizeSignature = (value) => String(value || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/\s+/g, ' ')
            .trim()
            .toLocaleLowerCase('pt-BR');
          const profileFor = (value) => {
            const signature = normalizeSignature(value);
            const hasAny = (terms) => terms.some((term) => signature.includes(term));

            if (signature.startsWith('kit ') || hasAny([' kit ', 'kit-', 'combo', ' unidades ', ' units ', '+'])) return 'bundle';
            if (hasAny(['ampola', 'ampoule'])) {
              if (signature.includes('sublime')) return 'ampoule_sublime';
              if (signature.includes('dream')) return 'ampoule_dream';
              if (signature.includes('magic')) return 'ampoule_magic';
              if (signature.includes('shine')) return 'ampoule_shine';
              if (signature.includes('curly')) return 'ampoule_curly';
              return 'ampoule_other';
            }
            if (hasAny(['home care liz', 'home-care-liz'])) return 'homecare_liz';
            if (hasAny(['home care marilyn', 'home-care-marilyn'])) return 'homecare_marilyn';
            if (signature.includes('brigitte') && hasAny(['shampoo pre', 'shampoo-pre'])) return 'prep_shampoo';
            if (hasAny(['btox', 'botox'])) return signature.includes('platinum') ? 'btox_blonde' : 'btox_general';
            if (signature.includes('grace') && signature.includes('violet')) return 'alignment_blonde';
            if (hasAny(['straightening', 'progressiv', 'alisador', 'enzimot', 'plastica dos fios', 'volume reduction', 'reducao de volume', 'semi-permanent', 'semi permanent'])) return 'alignment_general';

            return 'none';
          };
          const productProfile = profileFor(root.dataset.productSignature);

          cards.forEach((card) => {
            card.dataset.mbUpsellProfile = profileFor(card.dataset.mbUpsellSignature);
          });
          const prioritiesByProfile = {
            alignment_general: ['prep_shampoo', 'ampoule_sublime', 'homecare_liz', 'ampoule_dream'],
            alignment_blonde: ['prep_shampoo', 'ampoule_sublime', 'homecare_marilyn', 'ampoule_dream'],
            btox_general: ['prep_shampoo', 'ampoule_shine', 'homecare_liz'],
            btox_blonde: ['prep_shampoo', 'ampoule_shine', 'homecare_marilyn'],
            ampoule_dream: ['ampoule_magic'],
            ampoule_magic: ['ampoule_dream', 'ampoule_sublime', 'ampoule_shine'],
            ampoule_shine: ['ampoule_magic']
          };
          const selected = [];

          if (root.dataset.hasCuratedUpsell === 'true') {
            selected.push(...cards.slice(0, limit));
          } else {
            const priorities = prioritiesByProfile[productProfile] || [];

            priorities.forEach((profile) => {
              const match = cards.find((card) => card.dataset.mbUpsellProfile === profile && !selected.includes(card));
              if (match && selected.length < limit) selected.push(match);
            });
          }

          cards.forEach((card) => {
            card.hidden = !selected.includes(card);
          });
          upsell.hidden = selected.length === 0;

          if (rail) {
            const remaining = cards.filter((card) => !selected.includes(card));
            rail.replaceChildren(...selected, ...remaining);
          }

          const badge = upsell.querySelector('.mb-upsell__badge');
          if (badge && selected[0]) selected[0].prepend(badge);

          const purchaseButtons = info.querySelector('.product-form__buttons');
          const purchaseForm = purchaseButtons?.closest('product-form') || info.querySelector('product-form');
          const mainForm = purchaseForm?.querySelector('form[action*="/cart/add"]')
            || Array.from(info.querySelectorAll('form[action*="/cart/add"]')).find((form) => !form.closest('.mb-upsell') && form.querySelector('button[name="add"]'));
          const mainVariantInput = mainForm?.querySelector('input[name="id"]');
          const getMainCartItem = () => {
            const variantId = mainVariantInput?.value || mainVariantInput?.getAttribute('value') || root.dataset.mainVariantId;
            const quantityInput = mainForm?.querySelector('input[name="quantity"]');
            const quantity = Math.max(1, Number.parseInt(quantityInput?.value || '1', 10) || 1);
            const id = Number(variantId);
            return Number.isSafeInteger(id) && id > 0 ? { id, quantity } : null;
          };
          const addCartItems = async (items) => {
            const shopRoot = window.Shopify?.routes?.root || '/';
            const response = await window.fetch(`${shopRoot}cart/add.js`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({ items })
            });
            const result = await response.json();

            if (!response.ok) throw new Error(result.description || 'Não foi possível adicionar os produtos.');
            return { result, shopRoot };
          };

          upsell.querySelectorAll('.mb-upsell__form').forEach((form) => {
            if (form.dataset.mbBundleBound === 'true') return;
            form.dataset.mbBundleBound = 'true';

            form.addEventListener('submit', async (event) => {
              event.preventDefault();
              event.stopImmediatePropagation();

              const button = form.querySelector('button[type="submit"]');
              const status = form.querySelector('.mb-upsell__status');
              const upsellVariantInput = form.querySelector('input[name="id"]');
              const mainItem = getMainCartItem();
              const upsellVariantId = Number(upsellVariantInput?.value || upsellVariantInput?.dataset.mbUpsellVariant || upsellVariantInput?.getAttribute('value'));
              const upsellItem = Number.isSafeInteger(upsellVariantId) && upsellVariantId > 0 ? { id: upsellVariantId, quantity: 1 } : null;

              if (!button || !mainItem || !upsellItem) {
                if (status) {
                  status.hidden = false;
                  status.textContent = 'Não foi possível selecionar os dois produtos. Tente novamente.';
                }
                return;
              }

              const originalLabel = button.textContent;
              button.disabled = true;
              button.setAttribute('aria-busy', 'true');
              button.textContent = 'Adicionando os dois...';
              if (status) {
                status.hidden = true;
                status.textContent = '';
              }

              try {
                const { result, shopRoot } = await addCartItems([mainItem, upsellItem]);
                button.textContent = 'Adicionados ao carrinho';
                document.dispatchEvent(new CustomEvent('cart:refresh', {
                  detail: { source: 'mb-bundle', items: result.items || [] }
                }));
                window.setTimeout(() => window.location.assign(`${shopRoot}cart`), 350);
              } catch (error) {
                button.disabled = false;
                button.removeAttribute('aria-busy');
                button.textContent = originalLabel;
                if (status) {
                  status.hidden = false;
                  status.textContent = error.message || 'Não foi possível adicionar os produtos. Tente novamente.';
                }
              }
            }, { capture: true });
          });

          const storyContainer = info.querySelector('.sc-stories-component');
          const anchor = storyContainer || info.querySelector('[data-mb-dispatch]') || purchaseForm || info.lastElementChild;
          anchor?.insertAdjacentElement('afterend', upsell);
        }
      }

      const normalize = (value) => value.replace(/\s+/g, ' ').trim().toLocaleLowerCase('pt-BR');
      const paymentMarquee = document.querySelector('.mb-payment-marquee');
      paymentMarquee?.remove();

      const manufacturerKicker = Array.from(document.querySelectorAll('.mb-product-kicker > span'))
        .find((element) => normalize(element.textContent).includes('direto de quem fabrica'));
      if (manufacturerKicker) manufacturerKicker.textContent = 'Tecnologia profissional';

      document.querySelectorAll('.mb-benefit-drawer').forEach((drawer) => drawer.remove());

      const descriptionHeader = document.querySelector('.main-product-tabination');
      if (descriptionHeader) {
        const descriptionEyebrow = Array.from(descriptionHeader.querySelectorAll('*'))
          .find((element) => element.children.length === 0 && normalize(element.textContent) === 'informação para comprar com segurança');
        const descriptionTitle = Array.from(descriptionHeader.querySelectorAll('h2'))
          .find((element) => normalize(element.textContent) === 'conheça o protocolo antes de escolher');
        const descriptionIntro = Array.from(descriptionHeader.querySelectorAll('p'))
          .find((element) => normalize(element.textContent).includes('indicação, modo de uso e detalhes técnicos'));

        if (descriptionEyebrow) descriptionEyebrow.textContent = 'Guia completo do produto';
        if (descriptionTitle) descriptionTitle.textContent = 'Tudo para você ter o melhor resultado';
        if (descriptionIntro) descriptionIntro.textContent = 'Benefícios, ativos, aplicação e cuidados reunidos de forma simples e objetiva.';
      }

      const descriptionRoot = document.querySelector('#tab-1');

      if (descriptionRoot && !descriptionRoot.querySelector('.mb-description-topics')) {
        const nestedWrapper = descriptionRoot.children.length === 1 && descriptionRoot.firstElementChild?.tagName === 'DIV';
        const source = nestedWrapper ? descriptionRoot.firstElementChild : descriptionRoot;
        const directSections = Array.from(source.children).filter((element) => element.tagName === 'SECTION');
        const overviewSection = directSections.length > 1 ? directSections[0] : null;
        const descriptionElements = Array.from(source.children).filter((element) => {
          return element !== overviewSection && element.tagName !== 'HR';
        });

        if (descriptionElements.length) {
          const topics = document.createElement('div');
          const details = document.createElement('details');
          const summary = document.createElement('summary');
          const content = document.createElement('div');
          const mark = document.createElement('span');

          topics.className = 'mb-description-topics';
          details.className = 'mb-description-topic mb-description-topic--complete';
          details.open = true;
          summary.append(document.createTextNode('Descrição'), mark);
          mark.className = 'mb-description-topic__mark';
          mark.setAttribute('aria-hidden', 'true');
          content.className = 'mb-description-topic__content';
          content.append(...descriptionElements);
          details.append(summary, content);
          topics.appendChild(details);
          source.replaceChildren(topics);
        }
      }

      if (info && !info.querySelector('[data-mb-dispatch]')) {
        const purchaseButtons = info.querySelector('.product-form__buttons');
        const purchaseForm = purchaseButtons?.closest('product-form') || info.querySelector('product-form');
        const dispatch = document.createElement('aside');
        dispatch.className = 'mb-dispatch';
        dispatch.setAttribute('data-mb-dispatch', '');
        dispatch.setAttribute('aria-label', 'Informações de frete e despacho');
        dispatch.innerHTML = `
          <div class="mb-dispatch__row">
            <span class="mb-dispatch__icon" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path d="m13 2-8 12h7l-1 8 8-12h-7z"></path></svg></span>
            <span class="mb-dispatch__copy"><strong data-mb-dispatch-title>Envio expresso</strong><span data-mb-dispatch-copy></span></span>
          </div>`;

        purchaseForm?.insertAdjacentElement('afterend', dispatch);

        const title = dispatch.querySelector('[data-mb-dispatch-title]');
        const copy = dispatch.querySelector('[data-mb-dispatch-copy]');
        const updateDispatch = () => {
          const parts = Object.fromEntries(new Intl.DateTimeFormat('en-CA', {
            timeZone: 'America/Sao_Paulo',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23'
          }).formatToParts(new Date()).filter((part) => part.type !== 'literal').map((part) => [part.type, Number(part.value)]));
          const elapsed = (parts.hour * 3600) + (parts.minute * 60) + parts.second;
          const cutoff = 15 * 3600;

          if (elapsed < cutoff) {
            const remainingMinutes = Math.max(1, Math.ceil((cutoff - elapsed) / 60));
            const hours = Math.floor(remainingMinutes / 60);
            const minutes = remainingMinutes % 60;
            title.textContent = 'Envio expresso';
            copy.innerHTML = `Compre nas próximas <em>${hours ? `${hours}h e ` : ''}${minutes}min</em> e seu pedido será despachado <em>hoje</em>.`;
          } else {
            title.textContent = 'Envio expresso';
            copy.innerHTML = 'Comprando agora, seu pedido será despachado <em>amanhã</em>.';
          }
        };

        updateDispatch();
        window.setInterval(updateDispatch, 30000);

        const storyContainer = info.querySelector('.sc-stories-component');
        if (storyContainer) {
          storyContainer.classList.add('mb-stories-positioned');
          dispatch.insertAdjacentElement('afterend', storyContainer);
        }

        const upsell = root.querySelector('[data-mb-upsell]');
        const upsellAnchor = storyContainer || dispatch;
        if (upsell && upsellAnchor) upsellAnchor.insertAdjacentElement('afterend', upsell);
      }

      const heading = Array.from(document.querySelectorAll('.product-description h2, #tab-1 h2, .main-product-tabination h2'))
        .find((element) => /modo de uso|como usar/.test(normalize(element.textContent)));

      if (heading) {
        const protocol = heading.closest('section') || heading.parentElement;

        if (protocol && !protocol.classList.contains('mb-protocol-enhanced')) {
          const steps = Array.from(protocol.children).filter((element) => {
            const number = element.firstElementChild;
            const stepHeading = element.querySelector(':scope > div h3');
            return element.tagName === 'DIV' && number && stepHeading && /^\d+$/.test(number.textContent.trim());
          });

          if (steps.length > 1) {
            protocol.classList.add('mb-protocol-enhanced');

            const stage = document.createElement('div');
            const visual = document.createElement('div');
            const deck = document.createElement('div');
            const arrows = document.createElement('div');
            const previous = document.createElement('button');
            const next = document.createElement('button');
            const navigation = document.createElement('div');
            let active = 0;

            stage.className = 'mb-protocol__stage';
            visual.className = 'mb-protocol__visual';
            deck.className = 'mb-protocol__deck';
            arrows.className = 'mb-protocol__arrows';
            previous.className = 'mb-protocol__arrow';
            next.className = 'mb-protocol__arrow';
            navigation.className = 'mb-protocol__nav';
            navigation.setAttribute('role', 'tablist');
            navigation.setAttribute('aria-label', 'Etapas do modo de uso');
            navigation.style.setProperty('--mb-step-count', steps.length);
            previous.type = 'button';
            next.type = 'button';
            previous.setAttribute('aria-label', 'Passo anterior');
            next.setAttribute('aria-label', 'Próximo passo');
            previous.innerHTML = '‹';
            next.innerHTML = '›';

            if (root.dataset.productImage) {
              const image = document.createElement('img');
              image.src = root.dataset.productImage;
              image.alt = root.dataset.productAlt;
              image.loading = 'lazy';
              image.width = 1200;
              image.height = 1200;
              visual.appendChild(image);
            }

            protocol.insertBefore(stage, steps[0]);

            const tabs = steps.map((step, index) => {
              const number = step.firstElementChild;
              const stepHeading = step.querySelector('h3');
              const tab = document.createElement('button');
              step.classList.add('mb-protocol__panel');
              number.classList.add('mb-protocol__number');
              number.textContent = `Passo ${index + 1}`;
              step.id = `MbProtocolPanel-${root.dataset.sectionId}-${index}`;
              step.setAttribute('role', 'tabpanel');
              step.hidden = index !== 0;
              tab.type = 'button';
              tab.className = 'mb-protocol__tab';
              tab.id = `MbProtocolTab-${root.dataset.sectionId}-${index}`;
              tab.setAttribute('role', 'tab');
              tab.setAttribute('aria-controls', step.id);
              tab.setAttribute('aria-selected', index === 0 ? 'true' : 'false');
              tab.textContent = `Passo ${index + 1}`;
              step.setAttribute('aria-labelledby', tab.id);
              tab.title = stepHeading?.textContent.trim() || tab.textContent;
              navigation.appendChild(tab);
              deck.appendChild(step);
              return tab;
            });

            const selectStep = (index, options = {}) => {
              const target = Math.max(0, Math.min(index, steps.length - 1));
              const shouldScroll = options.scroll !== false;
              const shouldFocus = options.focus === true;
              const update = () => {
                active = target;
                steps.forEach((step, stepIndex) => {
                  step.hidden = stepIndex !== active;
                  tabs[stepIndex].setAttribute('aria-selected', stepIndex === active ? 'true' : 'false');
                  tabs[stepIndex].tabIndex = stepIndex === active ? 0 : -1;
                });
                previous.disabled = active === 0;
                next.disabled = active === steps.length - 1;
              };

              const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

              if (document.startViewTransition && !reducedMotion) {
                document.startViewTransition(update);
              } else {
                update();
              }

              if (shouldScroll) {
                tabs[target].scrollIntoView({ behavior: reducedMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
              }

              if (shouldFocus) tabs[target].focus();
            };

            tabs.forEach((tab, index) => {
              tab.addEventListener('click', () => selectStep(index));
              tab.addEventListener('keydown', (event) => {
                if (event.key === 'ArrowRight') {
                  event.preventDefault();
                  selectStep(active + 1, { focus: true });
                }
                if (event.key === 'ArrowLeft') {
                  event.preventDefault();
                  selectStep(active - 1, { focus: true });
                }
              });
            });

            previous.addEventListener('click', () => selectStep(active - 1));
            next.addEventListener('click', () => selectStep(active + 1));
            arrows.append(previous, next);
            deck.appendChild(arrows);
            stage.append(visual, deck);
            stage.insertAdjacentElement('afterend', navigation);
            selectStep(0, { scroll: false });
          }
        }
      }

      const offer = root.querySelector('[data-mb-offer]');

      if (offer) {
        const closeOffer = () => {
          offer.close();
          try {
            sessionStorage.setItem('mbOfferSeen', 'true');
          } catch (error) {
            return;
          }
        };

        offer.querySelectorAll('[data-mb-offer-close]').forEach((button) => button.addEventListener('click', closeOffer));
        offer.addEventListener('cancel', (event) => {
          event.preventDefault();
          closeOffer();
        });
        offer.addEventListener('click', (event) => {
          if (event.target === offer) closeOffer();
        });

        let seen = false;

        try {
          seen = sessionStorage.getItem('mbOfferSeen') === 'true';
        } catch (error) {
          seen = false;
        }

        if (!seen) {
          window.setTimeout(() => {
            if (!offer.open) offer.showModal();
          }, Number(offer.dataset.delay || 7000));
        }
      }
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => initialize());
    } else {
      initialize();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  })();

  } catch(e) { console.error(e); }
})();
})();
